import { SvgIconBase, } from "./Base";

export const WarningShield = (props: React.ComponentProps<typeof SvgIconBase>) => (
	<SvgIconBase {...props} viewBox="0 0 24 24">
		<g fill="none" fillRule="evenodd">
			{/* Triangle base with light fill */}
			<path
				d="M12 3L2.5 20h19L12 3Z"
				fill="currentColor"
				opacity="0.22"
			/>
			{/* Inner triangle stroke */}
			<path
				d="M12 3L2.5 20h19L12 3Z"
				stroke="currentColor"
				strokeWidth="1.25"
				fill="none"
			/>
			{/* Exclamation mark */}
			<rect
				x="11.25"
				y="9"
				width="1.5"
				height="5.2"
				rx="0.75"
				fill="currentColor"
			/>
			<circle
				cx="12"
				cy="16.25"
				r="1"
				fill="currentColor"
			/>
		</g>
	</SvgIconBase>
);
WarningShield.displayName = "WarningShield";
